<script lang="ts">
  import { fade } from "svelte/transition"
  import { X } from "lucide-svelte"
  //import colors from "tailwindcss/colors"

  export let flash: object = {}

  let flashes = Object.keys(flash).map((key) => ({
    key,
    value: flash[key],
    visible: true
  }))

  const styles = {
    success: "--tailwind",
    danger: "colors.red[500]",
    error: "colors.red[500]",
    info: "colors.blue[400]",
    warning: "colors.yellow[500]",
    notice: "colors.gray[400]",
    default: "colors.gray[400]"
  }

  function closeFlash(f): void {
    f.visible = false
    flashes = flashes
  }
</script>

<div id="flash-messages">
  {#each flashes as f}
    {#if f.visible}
      <div
        class="flash px-4 py-2 text-lg relative text-center text-white"
        style="background-color: {styles[f.key] || colors.gray['500']}"
        transition:fade
      >
        <button class="absolute top-1 left-2" on:click={() => closeFlash(f)}>
          <X color="white" />
        </button>
        {f.value}

        <div>
          <button class="text-xs" on:click={() => closeFlash(f)}>
            Close
          </button>
        </div>
      </div>
    {/if}
  {/each}
</div>
